<template>
    <div
        class="map-tab mg-scrollbar"
        :class="{
            'show-collapse': showCollapse,
            'show-business': !isMobile,
            detail: showDetail,
            expand: collapsed
        }"
        @click="replace && $emit('update:replace', false)"
        @mouseenter="replace && $emit('update:replace', false)"
    >
        <div class="tab-collapse" @click="collapsed = !collapsed">
            <i
                class="iconfont icon-more_arrow"
                :class="{ collapsed: collapsed }"
            ></i>
        </div>
        <div class="tab-header" v-show="!showDetail">
            <span
                v-for="tab in tabs"
                :key="tab.type"
                class="item"
                :class="[{ active: activeType === tab.type }, tab.type]"
                @click="activeType = tab.type"
            >{{ tab.label }}</span
            >
        </div>
        <div class="tab-body" v-show="!showDetail">
            <div
                v-for="tab in tabs"
                :key="tab.type"
                class="tab-content"
                :class="[{ 'more-panel': !!tab.moreLink }, tab.type]"
                v-show="activeType === tab.type"
            >
                <template v-if="tab.type === 'house'">
                    <ul v-if="tab.data" class="list">
                        <li
                            v-for="item in tab.data.slice(0, houseLimit)"
                            :key="item.id"
                            class="item"
                            :class="{
                                active:
                                    itemActiveKey ===
                                    'house-' +
                                    item.latitude +
                                    '-' +
                                    item.longitude
                            }"
                            @mouseenter="!isMobile && itemEnter('house', item)"
                            @mouseleave="itemLeave('house')"
                            @click="isMobile && itemEnter('house', item)"
                        >
                            <a
                                :href="transformLink2WordPress(item.detailLink)"
                                :target="getDetailTarget(item)"
                                rel="noopener noreferrer"
                            >
                                <p class="addr">
                                    {{ item.isShowMask ? $t('addressNotDisclosed') : item.formatAddress }}
                                </p>
                                <p
                                    v-if="item.commercialRealEstate"
                                    class="desc"
                                >
                                    <span
                                    >{{
                                        $t('md-map.sqft', {
                                            num: item.isShowMask ? '***' :
                                                (
                                                    item.sqft > -1
                                                        ? item.sqft
                                                        : '-'
                                                )
                                        })
                                    }}
                                        |</span
                                    >
                                    <span>{{ item.lotSizeWithUnit }} |</span>
                                    <span>{{ item.pricePerSqft }}</span>
                                </p>
                                <p v-else class="desc">
                                    <span
                                        class="vertical-line"
                                        v-if="item.bedrooms > 0"
                                    >{{ item.isShowMask ? $t('md-map.bed_one', { num : '***' }) : formatBed(item.bedrooms, 2) }}</span
                                    >
                                    <span
                                        class="vertical-line"
                                        v-if="item.bathrooms > 0"
                                    >{{
                                        item.isShowMask ? $t('md-map.bath_one', { num : '***' }) : formatBath(item.bathrooms, 2)
                                    }}</span
                                    >
                                    <span class="vertical-line">{{
                                        item.isShowMask ? $t('md-map.sqft', { num : '***' }) : formatSqft(item, 2)
                                    }}</span>
                                </p>
                                <p class="desc">
                                    {{
                                        item.propertyTypeText ||
                                            item.propertyType
                                    }}
                                </p>
                                <div class="house-mls-info">
                                    <div class="mls-info">
                                        <p
                                            v-if="
                                                item.mlsOrg.mlsOrgHas74 &&
                                                    item.mlsListingId
                                            "
                                        >
                                            MLS# {{ item.mlsListingId }}
                                        </p>
                                        <div v-if="item.provided && !item.isShowMask" v-html="item.provided"></div>
                                    </div>
                                    <div
                                        v-if="item.mlsLogo"
                                        class="house-mls-info-logo"
                                    >
                                        <site-img
                                            :src="item.mlsLogo"
                                            dir="height"
                                        ></site-img>
                                    </div>
                                </div>
                            </a>
                        </li>
                    </ul>
                    <div v-if="tab.moreLink && !wordPressSSR" class="more">
                        <a :href="tab.moreLink" rel="noopener noreferrer">{{
                            tab.moreLabel || $t('md-map.more')
                        }}</a>
                    </div>
                </template>
                <template v-else-if="tab.type === 'school'">
                    <template
                        v-for="(group, index) in tab.groups"
                        :key="group.label"
                    >
                        <div
                            class="group"
                            :class="{
                                active: schoolGroupActiveIndex === index
                            }"
                            @click="schoolGroupClick(index, group)"
                        >
                            {{ group.label }}
                            {{ group.data && group.data.length }}
                            <i class="iconfont icon-arrow_04_down"></i>
                        </div>
                        <ul class="list">
                            <li
                                v-for="item in group.data"
                                :key="item.id + '-' + (item.level || '')"
                                class="item server-property"
                                :class="{
                                    active:
                                        itemActiveKey ===
                                        'school-' +
                                        item.latitude +
                                        '-' +
                                        item.longitude
                                }"
                                @mouseenter="
                                    !isMobile &&
                                        itemEnter('school', item, true, true)
                                "
                                @mouseleave="itemLeave('school')"
                                @click="schoolItemClick(item)"
                            >
                                <div
                                    class="score"
                                    :class="[
                                        'score-' + item.gsRating,
                                        {
                                            high: item.gsRating > 9,
                                            middle:
                                                item.gsRating >= 6 &&
                                                item.gsRating <= 9,
                                            low:
                                                !item.gsRating ||
                                                item.gsRating < 6
                                        }
                                    ]"
                                >
                                    {{ item.gsRating || 0 }}
                                </div>
                                <p class="school-name">{{ item.name }}</p>
                                <p class="school-desc">
                                    {{ item.admission }} | {{ item.gradeLow }} -
                                    {{ item.gradeHigh }}
                                </p>
                            </li>
                        </ul>
                    </template>
                </template>
                <template v-else-if="tab.type === 'business'">
                    <template v-for="(group, index) in tab.groups" :key="index">
                        <div
                            class="group"
                            :class="{
                                active: businessGroupActiveIndex === index
                            }"
                            @click="businessGroupClick(index, group)"
                        >
                            {{ group.label }}
                            {{ group.data && group.data.length }}
                            <i class="iconfont icon-arrow_04_down"></i>
                        </div>
                        <ul class="list">
                            <li
                                v-for="item in group.data"
                                :key="item.id"
                                class="item"
                                :class="{
                                    active:
                                        itemActiveKey ===
                                        'business-' +
                                        item.latitude +
                                        '-' +
                                        item.longitude
                                }"
                                @mouseenter="
                                    !isMobile && itemEnter('business', item)
                                "
                                @mouseleave="itemLeave('business')"
                                @click="isMobile && itemEnter('business', item)"
                            >
                                <p class="name">{{ item.name }}</p>
                                <p class="detail">
                                    <a
                                        v-if="item.phone"
                                        class="tel"
                                        :href="'tel:' + item.phone"
                                        target="_top"
                                        rel="noopener noreferrer"
                                    >{{ $ft.formatPhone(item.phone) }}</a
                                    >
                                    <span>{{
                                        item.categoryTertiary ||
                                            item.categorySecondary ||
                                            ''
                                    }}</span>
                                </p>
                            </li>
                        </ul>
                    </template>
                </template>
            </div>
        </div>
        <div class="detail-header" v-show="showDetail">
            <span class="to-back" @click="detailBack">
                <i class="iconfont icon-prev"></i
                >{{ $t('md-map.backToPrevious') }}</span
            >
        </div>
        <div ref="detailBody" class="detail-body" v-show="showDetail">
            <div class="school" :class="{ 'more-panel': detailData.moreLink }">
                <p class="name">{{ detailData.name }}</p>
                <ul class="table">
                    <li
                        v-for="item in detailData.table"
                        :key="item.label"
                        class="item"
                    >
                        <p class="label">{{ item.label }}</p>
                        <p class="value">{{ item.value }}</p>
                    </li>
                </ul>
                <div
                    v-for="info in detailData.info"
                    :key="info.label"
                    class="info"
                >
                    <p class="label">{{ info.label }}</p>
                    <a
                        v-if="info.label === 'Phone'"
                        class="value"
                        :href="'tel:' + info.value"
                        target="_top"
                        rel="noopener noreferrer"
                    >{{ $ft.formatPhone(info.value) }}</a
                    >
                    <p v-else-if="info.label === 'Expenditure'" class="value">
                        {{ $ft.formatCurrency({ value: info.value, noSpace: true, currencySymbol}) }}
                    </p>
                    <p v-else class="value">{{ info.value }}</p>
                </div>
                <div v-if="detailData.moreLink && !wordPressSSR" class="more">
                    <a :href="detailData.moreLink" rel="noopener noreferrer">{{
                        detailData.moreLabel ||
                            $t('md-map.viewHomesInThisSchool')
                    }}</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import mapTab from '../map-tab';

export default {
    mixins: [mapTab]
};
</script>

<style lang="scss">
@import '../../../theme/mixin.scss';
@import '../../../theme/media.scss';

.md-map.broker {
    .map-tab {
        flex-shrink: 0;
        height: 100%;
        min-width: 320px;
        width: 0;
        position: absolute;
        left: 20px;
        top: 20px;
        bottom: 20px;
        transition: all 0.3s ease;
        width: 400px;
        height: 410px;
        padding: 20px 20px 0;
        background: #fff;
        border-radius: 5px;
        &.detail {
            padding: 0;
        }
        .tab-collapse {
            position: absolute;
            right: 0;
            top: 50%;
            transform: translate(100%, -50%);
            display: none;
            width: 50px;
            height: 50px;
            text-align: center;
            line-height: 50px;
            background: #fff;
            box-shadow: 2px 2px 10px 0 rgba(0, 10, 30, 0.1);
            border-radius: 5px;
            .icon-more_arrow {
                display: block;
                width: 22px;
                height: 50px;
                background-color: #fff;
                cursor: pointer;
                &:before {
                    color: #191919;
                    font-size: 16px;
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%) rotate(180deg);
                }
                &.collapsed {
                    &:before {
                        transform: translate(-50%, -50%) rotate(0deg);
                    }
                }
            }
            .icon-arrow-down {
                display: none;
            }
        }
        .tab-header {
            height: 32px;
            font-size: 14px;
            line-height: 22px;
            font-family: var(--font-normal);
            display: flex;
            overflow: hidden;
            background: #fff;
            border-radius: 5px 5px 0 0;
            border-bottom: 1px solid rgba(0, 0, 0, 0.15);
            .item {
                position: relative;
                color: #505050;
                padding: 0 20px 10px 0;
                cursor: pointer;
                font-size: 12px;
                margin-right: 20px;
                &.active {
                    font-size: 14px;
                    font-family: var(--font-bold);
                    color: var(--color-theme);
                }
                &.active:before {
                    position: absolute;
                    content: '';
                    display: block;
                    width: calc(100% - 20px);
                    height: 2px;
                    background: var(--color-theme);
                    left: 0;
                    bottom: 0px;
                }
                &.business {
                    display: none;
                }
            }
        }
        .tab-body {
            position: absolute;
            top: 52px;
            left: 0;
            bottom: 0;
            width: 100%;
            overflow: hidden;
            border-radius: 0 0 5px 5px;
            .tab-content {
                width: 100%;
                height: 100%;
                overflow: auto;
                background: #fff;
                .group {
                    font: 16px var(--font-bold);
                    line-height: 55px;
                    position: relative;
                    cursor: pointer;
                    color: #191919;
                    padding: 0 20px;
                    .icon-arrow_04_down {
                        position: absolute;
                        right: 20px;
                        &:before {
                            display: block;
                            font-size: 12px;
                            font-weight: bold;
                        }
                    }
                    + .list {
                        display: none;
                    }
                    &.active {
                        .icon-arrow_04_down {
                            &:before {
                                transform: rotate(180deg);
                            }
                        }
                        + .list {
                            display: block;
                        }
                    }
                }
                .list {
                    margin-top: -13px;
                }
                .item {
                    position: relative;
                    margin: 4px 0;
                    &:first-child {
                        margin-top: 0;
                        &:before {
                            display: none;
                        }
                    }
                    &:last-child {
                        margin-bottom: 0;
                    }
                    &:hover,
                    &.hover,
                    &.active {
                        background-color: #f8f9fd;
                    }
                }
                &.house {
                    .item {
                        height: auto;
                        padding: 13px 20px 10px 20px;
                        cursor: pointer;
                        .addr {
                            font-family: var(--font-medium);
                            font-size: 13px;
                            color: var(--color-text);
                            @include ellipsis();
                        }
                        .desc {
                            color: var(--color-label);
                            font-size: 12px;
                            &:last-of-type {
                                color: var(--color-disable);
                            }
                            .vertical-line {
                                &:after {
                                    content: ' |';
                                }
                                &:nth-last-child(1)::after {
                                    content: '';
                                }
                            }
                        }

                        .house-mls-info {
                            width: 100%;
                            display: flex;
                            .mls-info {
                                width: 80%;
                                font-size: 12px;
                                color: var(--color-label);
                                line-height: 14px;
                                margin-top: 10px;
                                display: block;
                            }
                            .house-mls-info-logo {
                                width: 20%;
                                display: flex;
                                justify-content: center;
                                align-items: center;
                                img {
                                    max-height: 40%;
                                    max-width: 100%;
                                }
                            }
                        }
                    }
                    .list {
                        margin-top: 0;
                    }
                }
                &.school {
                    .item {
                        position: relative;
                        height: 66px;
                        padding: 13px 20px 0 20px;
                        cursor: pointer;
                        .score {
                            float: left;
                            width: 40px;
                            height: 40px;
                            border-radius: 50%;
                            line-height: 40px;
                            font-size: 18px;
                            text-align: center;
                            color: #fff;
                            margin-right: 10px;
                            &.score-0 {
                                background-color: #f3fbf4;
                                color: #17b124;
                            }
                            &.score-1 {
                                background-color: #e7f7e9;
                                color: #17b124;
                            }
                            &.score-2 {
                                background-color: #d1efd3;
                                color: #17b124;
                            }
                            &.score-3 {
                                background-color: #b9e7bd;
                                color: #17b124;
                            }
                            &.score-4 {
                                background-color: #a2e0a7;
                                color: #17b124;
                            }
                            &.score-5 {
                                background-color: #8bd891;
                            }
                            &.score-6 {
                                background-color: #74d07c;
                            }
                            &.score-7 {
                                background-color: #5cc865;
                            }
                            &.score-8 {
                                background-color: #45c150;
                            }
                            &.score-9 {
                                background-color: #2eb839;
                            }
                            &.score-10 {
                                background-color: #17b124;
                            }
                        }
                        .school-name {
                            font-size: 14px;
                            font-family: var(--font-normal);
                            line-height: 14px;
                            margin-top: 4px;
                            color: #505050;
                            @include ellipsis();
                        }
                        .school-desc {
                            font-size: 14px;
                            font-family: var(--font-normal);
                            line-height: 18px;
                            color: #a8a8a8;
                            margin-top: 4px;
                        }
                    }
                }
                &.business {
                    .group {
                        border-bottom: 1px solid var(--color-border);
                    }
                    .item {
                        height: 66px;
                        padding: 13px 20px 0 20px;
                        cursor: pointer;
                        .name {
                            font-family: var(--font-medium);
                            font-size: 13px;
                            @include ellipsis();
                        }
                        .detail {
                            color: var(--color-info);
                            @include ellipsis();
                            .tel {
                                margin-right: 10px;
                            }
                        }
                    }
                }
            }
        }
        .detail-header {
            color: #fff;
            height: 40px;
            line-height: 40px;
            font-family: var(--font-medium);
            background-image: linear-gradient(to right, #ff8f44, #ff781d);
            overflow: hidden;
            .to-back {
                display: inline-block;
                position: relative;
            }
            .icon-prev {
                width: 24px;
                height: 24px;
                line-height: 24px;
                margin: 8px 12px 8px 10px;
                display: inline-block;
                vertical-align: top;
                cursor: pointer;
                &:before {
                    position: absolute;
                    width: 24px;
                    text-align: center;
                }
            }
        }
        .detail-body {
            position: absolute;
            top: 40px;
            bottom: 0;
            width: 100%;
            border-right: solid 1px #f0f1f5;
            border-bottom: solid 1px #f0f1f5;
            overflow: hidden;
            .school {
                .name {
                    margin: 20px;
                    font-family: var(--font-medium);
                    font-size: 20px;
                    line-height: 1.2;
                    position: relative;
                    &:before {
                        content: '';
                        width: 4px;
                        height: 100%;
                        display: block;
                        position: absolute;
                        left: -20px;
                        top: 0;
                        background: var(--color-theme);
                    }
                }
                .table {
                    padding: 5px 10px;
                    background-color: #f8f9fd;
                    display: flex;
                    flex-wrap: wrap;
                    justify-content: space-between;
                    .item {
                        flex-grow: 1;
                        padding: 10px;
                        .label {
                            color: #9699a3;
                            font-size: 12px;
                        }
                        .value {
                            font-family: var(--font-medium);
                            color: #8892a1;
                        }
                    }
                }
                .info {
                    padding: 5px 20px;
                    .label {
                        font-size: 12px;
                        color: #9699a3;
                    }
                    .value {
                        color: #656a78;
                    }
                }
                .more {
                    position: absolute;
                    bottom: 20px;
                    width: 100%;
                    @include color-theme();
                    text-align: center;
                    text-decoration: underline;
                    font-size: 14px;
                }
            }
        }
        .more-panel {
            padding-bottom: 30px;
            .more {
                position: absolute;
                width: 100%;
                font-size: 12px;
                height: 30px;
                line-height: 30px;
                bottom: 0;
                background-color: #f5fafe;
                text-align: center;
                a {
                    @include color-theme();
                    text-decoration: underline;
                }
            }
        }
        &.show-business {
            .tab-header {
                .item.business {
                    display: inline-block;
                }
            }
        }
        &.expand {
            transform: translateX(calc(-100% - 20px));
        }
        &.show-collapse {
            .tab-collapse {
                display: block;
            }
        }
    }
    @include media-600 {
        .map-tab {
            background-color: #fff;
            width: 100%;
            height: initial;
            user-select: none;
            position: static;
            border-radius: 5px;
            left: 0;
            position: absolute;
            top: 0;
            box-shadow: 2px 2px 10px 0 rgba(0, 10, 30, 0.1);
            .tab-header {
                .item {
                    max-width: 50%;
                }
            }

            .tab-body {
                position: relative;
                top: initial;
                bottom: initial;
                border: none;
                .tab-content {
                    .item {
                        + .item {
                            &:before {
                                left: 0;
                                right: 0;
                            }
                        }
                    }
                    &.school {
                        .item {
                            .score {
                                margin-right: 20px;
                            }
                        }
                    }
                    .group {
                        padding: 0;
                        .icon-arrow_04_down {
                            right: 0;
                        }
                    }
                    &.house {
                        .item {
                            padding: 13px 0 10px;
                        }
                    }
                }
            }
            .detail-body {
                position: relative;
                top: initial;
                bottom: initial;
                border: none;
                .school .more {
                    position: static;
                    margin-top: 20px;
                    background-color: #f5fafe;
                    line-height: 50px;
                    font-size: 12px;
                }
            }
            .more-panel {
                padding-bottom: 0;
                .more {
                    background: #fff;
                    height: initial;
                    line-height: 50px;
                    position: relative;
                    &:before {
                        content: '';
                        position: absolute;
                        display: block;
                        top: 2px;
                        left: 0;
                        right: 0;
                        border-top: none;
                    }
                }
            }
            &.show-collapse {
                position: relative;
                .tab-collapse {
                    display: none;
                }
                .tab-header,
                .tab-body {
                    display: flex;
                }
                &.collapsed {
                    margin-bottom: 30px;
                    .tab-collapse {
                        display: block;
                        left: 50%;
                        top: initial;
                        bottom: -40px;
                        transform: translate(-50%, -50%);
                        @include color-theme();
                        &:before {
                            content: 'MORE';
                            font-size: 14px;
                        }
                        .icon-expand {
                            display: none;
                        }
                        .icon-arrow-down {
                            display: inline-block;
                            position: relative;
                            margin-left: 10px;
                            width: auto;
                            height: 8px;
                            &:before {
                                @include color-theme();
                                transform: translate(-50%, -50%) scale(0.8)
                                    rotate(0deg);
                            }
                        }
                    }
                    .tab-header,
                    .tab-body {
                        display: none;
                    }
                }
            }
        }
    }
}
</style>
